import { EquipmentTypeDisplay, NodeBody, NodeContainer, NodeErrorIcon, NodeHeader, NodePrompts } from '@/nodes/NodeUI';
import type { ImageNodeType } from '@/nodes/types';
import type { GuideNodeId } from '@rock/types';
import { outgoingHandles } from '@rock/types';
import { Handle, type NodeProps, Position } from '@xyflow/react';
import { type FC, useContext } from 'react';
import { FlowParamsContext } from '../app/FlowInitializer';

export const ImageNode: FC<NodeProps<ImageNodeType>> = ({ id, selected, data }) => {
    const paths = outgoingHandles.image(id as GuideNodeId, data);
    const { spaceId } = useContext(FlowParamsContext);

    return (
        <NodeContainer>
            <NodeErrorIcon id={id} />
            <NodeHeader id={id} type={data.type} title={data.pageTitle} />
            <NodeBody selected={selected}>
                <NodePrompts prompts={data.prompts} />
                {data.equipmentTypeId && (
                    <div className="flex flex-col items-center justify-center p-1">
                        <EquipmentTypeDisplay spaceId={spaceId} typeId={data.equipmentTypeId} />
                    </div>
                )}
                <div className="my-2">{/*<Button size="sm">{data.buttonLabel || 'Button'}</Button>*/}</div>
            </NodeBody>

            <Handle type="target" position={Position.Left} />
            <Handle type="source" id={paths.next} position={Position.Right} />
        </NodeContainer>
    );
};
